import Svg, { Path } from 'react-native-svg'

export const HelpIcon = ({ height = 24, width = 24, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M12.095 1.617c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5Zm.685 14.378a.73.73 0 0 1-.723.732h-.055a.728.728 0 0 1-.722-.732v-.035a.73.73 0 0 1 .722-.733h.055c.398 0 .723.328.723.733v.035Zm1.28-4.213c-.34.38-.748.705-1.04 1.125-.153.22-.163.185-.258.443-.077.21-.03.5-.14.705-.177.33-.545.427-.895.28-.41-.175-.472-.588-.445-.985.03-.453.1-.645.325-1.048.215-.382.533-.69.835-1 .51-.522 1.28-1.435.448-2.067-.733-.558-1.728-.145-1.925.715-.09.392-.22.732-.613.862-.292.098-.605.028-.787-.222-.48-.658.137-1.835.625-2.32 1.247-1.243 3.74-.938 4.415.767l-.008-.017c-.017-.04-.025-.065-.027-.073.002.01.015.04.027.073l.008.017.032.085c-.005-.012-.017-.047-.032-.082.395.987.147 1.97-.545 2.742Z"
      />
    </Svg>
  )
}
